module.exports = __webpack_public_path__ + "static/my-order.e88b35f2.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Nav/imgs/my-order.png
// module id = 2743
// module chunks = 0